











import Vue from 'vue'

const MoonLoader = () => import('@/pmd/components/MoonLoader.vue')

export default Vue.extend({
  name: 'LoginUIAlert',
  components: {
    MoonLoader
  },
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (value: string) => ['info', 'success', 'warning', 'danger'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    typeClass(): string {
      return `login-ui-alert-${this.type}`
    }
  }
})
